import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { catchError, Observable, of } from 'rxjs';
import { BUILD_ID } from '~/build-info';

export class CustomTranslateHttpLoader implements TranslateLoader {
  constructor(private readonly httpClient: HttpClient) {}
  /**
   * Gets the translations from the server.
   * Appends a unique per-build id as a cache-busting query param so every deploy
   * always fetches a fresh translation file instead of a stale immutable-cached copy.
   */
  public getTranslation(lang: string): Observable<TranslationObject> {
    return this.httpClient.get<TranslationObject>(`./assets/i18n/${lang}.json?v=${BUILD_ID}`).pipe(
      catchError((error) => {
        console.error(`Failed to load translations for language "${lang}"`, error);
        return of({});
      })
    );
  }
}
